import cx                   from 'classnames';
import $                    from 'jquery';
import React, { PropTypes } from 'react';
import ReactDom             from 'react-dom';
import VideoActions         from 'actions/video_actions';
import HasSliderEvents      from 'mixins/has_slider_events';
import { isDescendant }     from 'utils/util';


export default React.createClass({
  displayName: 'Player.VolumeSlider',
  propTypes: {
    currentVolume: PropTypes.number,
          hasMute: PropTypes.bool,
     isFullScreen: PropTypes.bool
  },
  mixins: [ HasSliderEvents ],
  getDefaultProps() {
    return {
      currentVolume: 0.75,
            hasMute: true
    };
  },
  getInitialState() {
    return {
         lastVolume: 0.75,
      percentHeight: 75,
       parentHeight: 70
    };
  },
  shouldComponentUpdate(nextProps, nextState) {
    if(this.state.isActive !== nextState.isActive) {
      return true;
    }
    if(this.state.isDragging === true) {
      return true;
    } if(nextProps.currentVolume !== this.props.currentVolume) {
      return true;
    } else {
      return false;
    }
    return true;
  },
  onMouseMove(e) {
    const        $this = $(ReactDom.findDOMNode(this)),
         percentHeight = this.getStyle(($this.offset().top - e.pageY), this.state.parentHeight, this.props.isFullScreen);
    this.setState({
      percentHeight: percentHeight
    });
  },
  onTouchMove(e) {
    e.preventDefault();
    const        $this = $(ReactDom.findDOMNode(this)),
                 touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
         percentHeight = this.getStyle(($this.offset().top - touch.pageY), this.state.parentHeight, this.props.isFullScreen);
    this.setState({
      percentHeight: percentHeight
    });
  },
  setVolume(e) {
    e.preventDefault();
    VideoActions.setVolume(this.getSliderValueY(e, 1));
  },
  getCursorStyle(elapsed, total) {
    const num = Math.floor(((elapsed / total) * 10) + 20);
    return  {
      'top': `${num}px`
    };
  },
  getStyle(elapsed, total, fullscreen) {
    let percent;
    if(fullscreen === true) {
      percent = ((elapsed /  document.documentElement.offsetHeight) * 100).toFixed(2);
    } else {
      percent = ((elapsed / total) * 100).toFixed(2);
    }
    if(isNaN(percent) || percent < 0) {
      percent = 0;
    } else if(percent > 100) {
      percent = 100;
    }
    return percent;
  },
  killEvent(e) {
    e.stopPropagation();
  },
  showVolumeBar() {
    this.setState({
      isActive: true
    });
  },
  hideVolumeBar(e) {
    let isActive = false;
    if(e.relatedTarget === document.querySelector('.video-player-progress-bar-wrap') ||
       e.relatedTarget === document.querySelector('.video-player-elapsed-time-indicator') ||
       e.relatedTarget === document.querySelector('.video-player-loaded-bar') ||
       isDescendant(document.querySelector('.video-player-volume-slider'), e.relatedTarget)) {
      isActive = true;
    }
    this.setState({
      isActive: isActive
    });
  },
  dragStart(e) {
    e.stopPropagation();
    this.setState({
      isDragging: true,
           dragY: 0
    });
    $(document).on('mousemove.drag', this.onMouseMove);
    $(document).on('mouseup.drag', this.dragEnd);
    $(document).on('touchmove', this.onTouchMove);
    $(document).on('touchend', this.dragEnd);
  },
  dragEnd(e) {
    const        $this = $(ReactDom.findDOMNode(this)),
         percentHeight = this.getStyle(($this.offset().top - e.pageY), this.state.parentHeight, this.props.isFullScreen);
      this.setState({
        percentHeight: percentHeight
      });
    if(this.state.isDragging === false) {
      return;
    } else {
      $(document).off('mousemove.drag');
      $(document).off('mouseup.drag');
      $(document).on('touchmove');
      $(document).on('touchend');
      VideoActions.setVolume(percentHeight/100);
      this.setState({
        isDragging: false
      });
    }
  },
  mute(e) {
    e.preventDefault();
    if(this.props.currentVolume === 0) {
      VideoActions.unmute(this.state.lastVolume);
    } else {
      this.setState({ lastVolume: this.props.currentVolume });
      VideoActions.mute(0);
    }
  },
  render() {
    const currentVolume     = this.props.currentVolume,
          volumeButtonClass = cx({
            'video-player-volume-muted-button': currentVolume === 0,
              'video-player-volume-low-button': currentVolume > 0  && currentVolume <= 0.33,
              'video-player-volume-med-button': currentVolume > 0.33 && currentVolume <= 0.66,
             'video-player-volume-high-button': currentVolume > 0.66,
                  'video-player-volume-button': true
          }),
          mute        = this.props.hasMute? <button ref="muteButton"
                                                    className={volumeButtonClass}
                                                    onClick={this.mute}>M</button> : null,
          classNames  = cx({
            'video-player-volume-slider': true,
                              'is-muted': this.props.currentVolume === 0,
                             'is-active': this.state.isActive
          }),
          grabLine = cx({
                             grabbable: true,
            'video-player-volume-line': true
          }),
          indicatorCN = cx({
                                  grabbable: true,
            'video-player-volume-indicator': true
          }),
          wrapCN = cx({
                                      grabbable: true,
            'video-player-volume-boundary-wrap': true
          });
    return (<div className={classNames} onMouseEnter={this.showVolumeBar} onMouseOut={this.hideVolumeBar}>
        { mute }
        <div className={wrapCN} onMouseOut={this.hideVolumeBar}>
          <div className="video-player-volume-boundary"
                onClick={this.killEvent}
                onMouseDown={this.dragStart}
                onMouseUp={this.dragEnd}
                onTouchStart={this.dragStart}
                onTouchEnd={this.dragEnd}
                onTouchMove={this.touchMove}>
            <div className={grabLine}> </div>
            <div className={indicatorCN} style={{height: `${this.state.percentHeight}%`}}>
              <div className="video-player-volume-indicator-icon"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./modules/components/player/volume_slider.jsx